
admin.registerLoad(function (prefix) {

    $(prefix + '.js-summernote').each(function () {

        var textarea = $(this);

        /**
         * Choose image Button
         *
         * @param context
         * @returns {*}
         * @constructor
         */
        var ImageButton = function (context) {
            var ui = $.summernote.ui;

            /**
             * Perform the insert after the image has been selected
             *
             * @param result
             */
            function choose_image(result) {

                if (result.status != 201) {
                    alert(result.errors[0].message);
                    return;
                }

                // we have a valid media back, lets update our form field and all that other stuff needed
                var image_url = result.urls.origimage;

                // insert image at 50% width
                context.invoke('editor.insertImage', image_url, function (image) {
                    $(image).css("width", "50%");
                    $(image).addClass("width-50");
                });
            }

            /**
             * Load media library via url
             *
             * Sets up all events on the library
             *
             * @param url
             */
            function load_media_library_url(url) {
                $('#media-library-modal').html($('#modal-wait-template').html());
                $('#media-library-modal .modal-content').load(url, function () {
                    // once a library is loaded, hook all its links to load in the frame instead of page
                    $(this).find("a").click(function (ev) {
                        ev.preventDefault();
                        load_media_library_url($(this).attr('href'));
                    });

                    $(this).find("select").change(function () {
                        load_media_library_url($(this).val());
                    })

                    $(this).find('.js-media-image').unbind("click");
                    $(this).find('.js-media-image').click(function (ev) {
                        ev.preventDefault();
                        $('#media-library-modal').modal("hide");
                        choose_image($(this).data("media"));
                    })
                });
            }

            /**
             * Actual button implementation
             */
            var button = ui.button({
                contents: '<i class="note-icon-picture"/> Pick Image',
                tooltip: 'Choose Image',
                click: function () {
                    load_media_library_url(textarea.data('choose-url'));
                    $('#media-library-modal').modal();
                }
            });

            return button.render();   // return button as jquery object
        };

        /**
         * Upload file button
         *
         * @param context
         * @returns {*}
         * @constructor
         */
        var UploadImageButton = function (context) {
            var ui = $.summernote.ui;

            // create button
            var button = ui.button({
                contents: '<i class="note-icon-picture"/> Upload Image',
                tooltip: 'Upload Image',
                click: function () {
                    $('#media-upload').unbind("change");
                    $('#media-upload').change(function (ev) {

                        $('#media-upload-form').submit();
                    });

                    $('#media-upload-type').val(textarea.data('upload-set'));

                    $('#media-upload-iframe').unbind("load");
                    $('#media-upload-iframe').load(function () {

                        try {
                            var text = $('#media-upload-iframe').contents().text();
                            if (text.indexOf("{") != 0)
                            {
                                text = text.substr(text.indexOf("{"));
                            }
                            var result = $.parseJSON(text);

                            if (result.status != 201) {
                                alert(result.errors[0].message);
                                return;
                            }

                            // we have a valid media back, lets update our form field and all that other stuff needed
                            var image_url = result.urls.origimage;

                            // insert image at 50% width
                            context.invoke('editor.insertImage', image_url, function (image) {
                                $(image).css("width", "50%");
                                $(image).addClass("width-50");
                            });

                        } catch (e)
                        {
                            alert(e);
                            return;
                        }

                    });

                    $('#media-upload').click();
                }
            });

            return button.render();   // return button as jquery object
        };

        textarea.summernote({
            minHeight: 250,             // set minimum height of editor
            imageTitle: {
                specificAltField: true,
            },
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', 'clear']], //
                //['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                //['table', ['table']],
                ['insert', ['link', 'unlink', 'bcimage', 'bcupload', 'video', 'hr']],
                ['view', [/*'fullscreen',*/ 'codeview'/*, 'help'*/]]
            ],
            styleTags: ['p', 'blockquote', 'pre', /*'h1', 'h2',*/ 'h3', 'h4', 'h5', 'h6'],
            buttons: {
                bcimage: ImageButton,
                bcupload: UploadImageButton
            },
            popover: {
                image: [
                    /*['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],*/
                    ['imageWidth', ['imageWidth100', 'imageWidth50', 'imageWidth25']],
                    ['floatBS', ['floatBSLeft', 'floatBSNone', 'floatBSRight']],
                    ['remove', ['removeMedia']],
                    ['custom', ['imageTitle']],
                ]
            },
            disableResizeImage: true
        });

        textarea.on("summernote.paste", function (e, ne) {
            var bufferText = ((ne.originalEvent || ne).clipboardData || window.clipboardData).getData('Text');
            ne.preventDefault();
            document.execCommand('insertText', false, bufferText);
        });
    });
});